export enum PlaybackTokenType {
	CloudFrontToken = 'vbcftkn',
	VBToken = 'vbtkn'
}
